import { createReducer, on } from '@ngrx/store';

import { ScannerState, ScannerStatus } from '../models';

import {
  addToBasket,
  addToBasketFail,
  addToBasketSuccess,
  addToListFail,
  addToListSuccess,
  barcodeDuped,
  barcodeRead,
  clearBarcodeResults,
  clearCurrentBarcodeForNext,
  findProduct,
  productFound,
  productNotFound,
  targetChange,
} from './barcode-reader.actions';

const initial: ScannerState = {
  status: {
    description: ScannerStatus.SETUP,
  },
  loadingProduct: false,
  barcodeReadingResults: [],
};

export const scannerReducer = createReducer<ScannerState>(
  initial,

  on(clearBarcodeResults, (state) => ({
    ...state,
    barcodeReadingResults: [],
  })),

  on(barcodeRead, (state, action) => ({
    ...state,
    currentBarcode: action.barcode,
  })),

  on(findProduct, (state, action) => ({
    ...state,
    loadingProduct: true,
    status: {
      description: ScannerStatus.SEARCHING,
      barcode: action.barcode,
    },
  })),

  on(productFound, (state) => ({
    ...state,
    loadingProduct: false,
  })),

  on(productNotFound, (state, action) => ({
    ...state,
    loadingProduct: false,
    status: {
      description: ScannerStatus.NOT_FOUND,
      barcode: action.barcode,
    },
  })),

  on(addToListSuccess, (state, action) => ({
    ...state,
    status: {
      description: ScannerStatus.ADDED_TO_LIST,
      barcode: action.barcode,
    },
    barcodeReadingResults: [
      ...state.barcodeReadingResults,
      {
        ...action,
        added: true,
      },
    ],
  })),

  on(addToListFail, (state, action) => ({
    ...state,
    status: {
      description: action.reason ?? ScannerStatus.ERROR_ADD_LIST,
      barcode: action.barcode,
    },
    barcodeReadingResults: [
      ...state.barcodeReadingResults,
      {
        ...action,
        added: false,
      },
    ],
  })),

  on(addToBasket, (state, action) => ({
    ...state,
    status: {
      description: ScannerStatus.ADDING_TO_BASKET,
      barcode: action.barcode,
    },
  })),

  on(addToBasketSuccess, (state, action) => ({
    ...state,
    status: {
      description: ScannerStatus.ADDED_TO_BASKET,
    },
    barcodeReadingResults: [
      ...state.barcodeReadingResults,
      {
        ...action,
        added: true,
      },
    ],
  })),

  on(addToBasketFail, (state, action) => ({
    ...state,
    status: {
      description: action.reason ?? ScannerStatus.ERROR_ADD_BASKET,
    },
    barcodeReadingResults: [
      ...state.barcodeReadingResults,
      {
        ...action,
        added: false,
      },
    ],
  })),

  on(targetChange, (state, action) => ({
    ...state,
    target: action.target,
  })),

  on(barcodeDuped, (state, action) => ({
    ...state,
    status: {
      description: ScannerStatus.DUPED,
      barcode: action.barcode,
    },
  })),

  on(clearCurrentBarcodeForNext, (state) => ({
    ...state,
    status: {
      description: ScannerStatus.SETUP,
    },
    currentBarcode: undefined,
  })),
);
